import { registerAppLinks } from "@shared/services/appLinkRegistry";

registerAppLinks([]);
